import { render, staticRenderFns } from "./update-prompt.vue?vue&type=template&id=2afe7e86&"
import script from "./update-prompt.vue?vue&type=script&lang=js&"
export * from "./update-prompt.vue?vue&type=script&lang=js&"
import style0 from "./update-prompt.vue?vue&type=style&index=0&id=2afe7e86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports